__turbopack_context__.v({
  "listItem": "AuthorHeaderSocialMediaAccount-module-scss-module__3a9LlW__listItem",
});
